import { createEntityReducer } from "@selas/state-management";

import Endpoint from "../../services/api/endpoint";
import { IMaterialCategory } from "../../utils/types/models";

export default createEntityReducer<IMaterialCategory>(Endpoint.MaterialCategories, Endpoint.MaterialCategoriesList);
